'use strict';

(() => {
  document.documentElement.classList.replace('no-js', 'js');

  function init(scope) {
    scope.querySelectorAll('[data-gallery]').forEach((gallery) => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const main = gallery.querySelector('.gallery-main');
      const image = main && main.querySelector('img');
      const zoom = gallery.querySelector('[data-gallery-zoom]');
      if (zoom) zoom.addEventListener('click', () => {
        const active = zoom.classList.toggle('is-zoomed');
        zoom.setAttribute('aria-pressed', String(active));
        zoom.setAttribute('aria-label', active ? 'Zoom out' : 'Zoom in on the product image');
        const indicator = zoom.querySelector('.zoom-indicator');
        if (indicator) indicator.textContent = active ? '−' : '+';
      });
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', (event) => {
          if (!image || !zoom) return;
          event.preventDefault();
          image.src = thumb.dataset.src;
          image.srcset = `${thumb.dataset.small} 640w, ${thumb.dataset.src} ${thumb.dataset.width || 1024}w`;
          image.alt = thumb.dataset.alt || '';
          zoom.classList.remove('is-zoomed');
          zoom.setAttribute('aria-pressed', 'false');
          zoom.setAttribute('aria-label', 'Zoom in on the product image');
          const indicator = zoom.querySelector('.zoom-indicator');
          if (indicator) indicator.textContent = '+';
          gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
            item.classList.toggle('is-selected', item === thumb);
            item.setAttribute('aria-current', String(item === thumb));
          });
        });
      });
    });

    scope.querySelectorAll('[data-product-root]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const select = root.querySelector('[data-variant-select]');
      const form = root.querySelector('.purchase-form');
      const quantity = root.querySelector('[data-quantity]');
      if (!select || !form) return;
      const buttons = root.querySelectorAll('[data-add-button]');
      const swatches = root.querySelectorAll('[data-variant-id]');
      const synchronize = () => {
        const option = select.selectedOptions[0];
        const available = Boolean(option && option.dataset.available === 'true');
        root.querySelectorAll('[data-product-price]').forEach((el) => { el.textContent = option ? option.dataset.price : 'Unavailable'; });
        const compare = root.querySelector('[data-product-compare]');
        if (compare) { compare.textContent = option ? option.dataset.compare : ''; compare.hidden = !option || !option.dataset.compare; }
        const label = root.querySelector('[data-selected-colour]');
        if (label) label.textContent = option ? option.dataset.colour : '';
        buttons.forEach((button) => { button.disabled = !available; button.textContent = available ? 'Add to cart' : 'Sold out'; });
        swatches.forEach((button) => {
          const selected = button.dataset.variantId === select.value;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
      };
      select.addEventListener('change', synchronize);
      swatches.forEach((button) => button.addEventListener('click', () => {
        const option = Array.from(select.options).find((item) => item.value === button.dataset.variantId);
        if (!option || option.disabled) return;
        select.value = option.value;
        select.dispatchEvent(new Event('change', {bubbles: true}));
      }));
      root.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => {
        if (!quantity) return;
        const current = Number.parseInt(quantity.value, 10) || 1;
        const minimum = Number.parseInt(quantity.min, 10) || 1;
        const maximum = Number.parseInt(quantity.max, 10) || 99;
        quantity.value = String(Math.max(minimum, Math.min(maximum, current + Number(button.dataset.quantityChange))));
        quantity.dispatchEvent(new Event('change', {bubbles: true}));
      }));
      form.addEventListener('submit', (event) => {
        const option = select.selectedOptions[0];
        if (!form.reportValidity() || !option || option.dataset.available !== 'true') { event.preventDefault(); return; }
        // Native navigation to Shopify's cart: no simulated checkout or API credentials.
        form.setAttribute('aria-busy', 'true');
        buttons.forEach((button) => { button.disabled = true; button.textContent = 'Adding…'; });
      });
      synchronize();
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.purchase-form[aria-busy="true"]').forEach((form) => {
      form.removeAttribute('aria-busy');
      const select = form.querySelector('[data-variant-select]');
      if (select) select.dispatchEvent(new Event('change', {bubbles: true}));
    });
  });
})();
